import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { fetchData } from './requestActions';
import { ErrorResponseDetails } from '@ts/ui-models';

interface RequestData {
  data: any;
  loading: boolean;
  error: ErrorResponseDetails | null;
}

export interface Request {
  loading: boolean;
  error: ErrorResponseDetails | null;
  request: Record<string, RequestData>;
}
type RequestKey = keyof Request;

const initialState: Record<string, RequestData> = {
  global: {
    data: null,
    loading: false,
    error: null,
  },
};
export const requestSlice = createSlice({
  name: 'request',
  initialState,
  reducers: {
    cleanError(state) {
      state['global'].error = null;
    },
    cleanKey(state, { payload }: PayloadAction<string>) {
      const key = payload;
      if (key) {
        delete state[key];
      }
    },
    updateRequestState(state, action: PayloadAction<{ key: RequestKey; value: any }>) {
      const { key, value } = action.payload;
      if (key) {
        state['global'][key] = value;
      }
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchData.pending, (state, action) => {
        const { key } = action.meta.arg;

        if (!key) return;
        if (!state[key]) {
          state[key] = { data: undefined, loading: true, error: null };
        } else {
          state[key].data = undefined;
          state[key].loading = true;
          state[key].error = null;
        }
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        const { key, data } = action.payload || {};

        if (key && state[key]) {
          state[key].data = data;
          state[key].loading = false;
          state[key].error = null;
        }
      })
      .addCase(fetchData.rejected, (state, action) => {
        const errorPayload = (action.payload as any)?.error;
        const { key } = action.meta.arg;
        const { error } = action;

        if (key && state[key]) {
          state[key].data = null;
          state[key].loading = false;
          state[key].error = errorPayload ?? error;
        } else {
          state['global'].error = errorPayload ?? error;
        }
      });
  },
});

export const requestActions = requestSlice.actions;

export default requestSlice.reducer;
